const statusFlow = [
  'Receiving',
  'Incoming',
  'Opening',
  'LCD Buffing',
  'Warehouse ATA',
  'Matching Kit For Assembly',
  'Phone Closing',
  'Quality Inspection',
  'Oleophobic And Overlay',
  'Packaging',
  'Finish Good'
];

const failurePaths = {
  'Receiving': 'Warehouse Scrap',
  'Incoming': 'Warehouse Scrap',
  'Opening': 'Warehouse Scrap',
  'LCD Buffing': 'Warehouse Scrap',
  'Matching Kit For Assembly': 'Phone Rework',
  'Phone Closing': 'Phone Rework',
  'Quality Inspection': 'Phone Rework',
  'Oleophobic And Overlay': 'Phone Rework',
  'Packaging': 'Phone Rework',
  'Phone Rework': 'Quality Inspection'
};

const isFailureStatus = (status) => {
  return status === 'Warehouse Scrap' || status === 'Phone Rework';
};

const getNextStepLabel = (currentStatus) => {
  if (currentStatus === 'Warehouse ATA') return 'Mover a Producción';
  if (currentStatus === 'Phone Rework') return 'Pasar a Producción';
  if (currentStatus === 'Warehouse Scrap') return 'Pasar a Producción';
  return 'PASA';
};

const failureCodes = [
  { code: 'LCD001', description: 'Pantalla rota' },
  { code: 'LCD002', description: 'Pantalla con manchas' },
  { code: 'LCD003', description: 'Pantalla no responde' },
  { code: 'BAT001', description: 'Batería no carga' },
  { code: 'BAT002', description: 'Batería se descarga rápido' },
  { code: 'BAT003', description: 'Batería inflada' },
  { code: 'PCB001', description: 'Placa madre dañada' },
  { code: 'PCB002', description: 'Problema de conectividad' },
  { code: 'PCB003', description: 'Corto circuito' },
  { code: 'CAM001', description: 'Cámara trasera no funciona' },
  { code: 'CAM002', description: 'Cámara frontal no funciona' },
  { code: 'CAM003', description: 'Flash no funciona' },
  { code: 'AUD001', description: 'Altavoz no funciona' },
  { code: 'AUD002', description: 'Micrófono no funciona' },
  { code: 'AUD003', description: 'Auricientes no funcionan' },
  { code: 'HSG001', description: 'Carcasa dañada' },
  { code: 'HSG002', description: 'Botones no funcionan' },
  { code: 'HSG003', description: 'Puerto lightning dañado' }
];

export { statusFlow, failurePaths, isFailureStatus, getNextStepLabel, failureCodes };